const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);
const SAME_ORIGIN_API_PREFIXES = new Set(['/api', '/invoicing', '/recipients', '/documents']);

export function resolveApiBaseUrl(input: string | undefined, fallback: string): string {
  const raw = (input ?? fallback).trim();
  if (raw === '' || raw === '/api') {
    return '/api';
  }

  if (raw.startsWith('/')) {
    const trimmedRelative = raw.replace(/\/$/, '');
    if (SAME_ORIGIN_API_PREFIXES.has(trimmedRelative)) {
      return trimmedRelative === '/api' ? '/api' : `${trimmedRelative}/api`;
    }
    if ([...SAME_ORIGIN_API_PREFIXES].some((prefix) => trimmedRelative === `${prefix}/api`)) {
      return trimmedRelative;
    }
    throw new Error(
      'API base URL relativa no permitida; use /api, un proxy same-origin conocido o una URL absoluta segura.',
    );
  }

  let url: URL;
  try {
    url = new URL(raw);
  } catch {
    throw new Error('API base URL inválida; use https:// o http://localhost en DEV.');
  }

  if (url.protocol !== 'https:' && !(url.protocol === 'http:' && LOOPBACK_HOSTS.has(url.hostname))) {
    throw new Error('API base URL insegura; use https:// o http://localhost en DEV.');
  }

  const trimmed = url.href.replace(/\/$/, '');
  return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
}
